/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentScheduleJournalItemResponse } from './equipment-schedule-journal-item-response';


export interface EquipmentScheduleJournalItemResponsePagedList { 
    totalCount?: number;
    items?: Array<EquipmentScheduleJournalItemResponse> | null;
}

